export default {
      id: "icon-tg-usage",
      viewBox: "0 0 240.1 240.1",
      url: __webpack_public_path__ + "assets/template/sprite/sprite.svg#icon-tg",
      toString: function () {
        return this.url;
      }
    }